import React, { Component } from "react";
import Footer from "../components/Footer";
import Navbar from "../components/NavBar";
import img from "../imgs/roadRain.jpeg";
import mp from '../imgs/mp.jpeg';

const jumbotron = {
  backgroundImage: "url(" + img + ")",
  backgroundPosition: "center",
  backgroundRrepeat: "no-repeat",
  backgroundSize: "cover",
  color: "white",
  height: "100vh"
};



export default class Bio extends Component {
  render() {
    return (
      <div>
        <Navbar />
        <div className="jumbotron jumbotron-fluid" style={jumbotron}>
        
          <div className="container ">
          <h1 className="display-3" style={{ float:'center', fontSize:"4vh", fontFamily:'lato' }}>
                MELINEH PETROSIAN
              </h1>
            <div className="row-fluid" style={{textAlign:'center'}}>
            
            <div className="col-lg-6" style={{float:'left', width:'40vh',backgroundColor:'rgba(0, 0, 0, 0.4)' , borderRadius:' 15px ', marginTop:'8vh'}}>


            <p style={{color: 'white',fontSize: '1.75vh', textAlign:' justify',textJustify:' inter-word' ,margin:'1vh'}}>Petrosian is a self-made woman, born in 1963 to an Armenian family in
                        Tehran, Iran. She endured regular abuse from a mother who suffered with
                        border-line personality disorders as well as other mental illnesses. Despite
                        being suppressed regularly for her talents, Petrosian&apos;s love for poetry
                        and narrative writing has been a constant through the years, finding published
                        status in several Farsi magazines. She finally writes the bitter yet poignant
                        tale of growing up in a war-torn country and home, neither of which she
                        could escape. Before migrating to the United States in 1987, she lived
                        in Athens, Greece, for almost two years. She earned not only a cosmetology
                        license, but also one in naturopathic science and massage therapy and has
                        been in practice for over twenty-five years. Petrosian is fluent in four
                        languages and is actively involved in Houston Writers&#x2019; Guild and
                        as well as multiple writers&#x2019; critique groups.</p>
              
              
            </div>
            <div className="col-lg-6" style={{float: 'right', width:'50vh'}}>
                    <img className="" src={mp} style={{height: '50vh',marginTop: '10vh'}}/> 
                </div>
          </div>
        </div>
        {/* <Footer/> */}
      </div>
      </div>
    );
  }
}
